import React from 'react';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import LinkIcon from '@material-ui/icons/Link';
import Box from '@material-ui/core/Box';
import {Fonts} from '../../../shared/constants/AppEnums';
import AppAnimate from '../AppAnimate';
import styled from 'styled-components';

const StyledComponentHeader = styled(Box)`
  ${({theme}) => `
    display: flex;
    flex-direction: column;
     ${[theme.breakpoints.up('sm')]} {
      flex-direction: row;
      justify-content: space-between;
    }
    padding-bottom: 16px;
     ${[theme.breakpoints.up('xl')]} {
      padding-top: 16px;
    }
      
   .linkIcon {
      padding-left: 4px;
    }
    .textbase {
      font-size: 16px;
    }
  `}
`;

const ComponentHeader = ({title, description, refUrl}) => {
  return (
    <AppAnimate animation='transition.slideDownIn' delay={300}>
      <StyledComponentHeader>
        <Box mb={3} pr={{sm: 3}} flex={{sm: 1}}>
          <Box
            component='h3'
            color='text.primary'
            fontFamily={Fonts.LIGHT}
            fontSize={{xs: 18, sm: 20, xl: 22}}>
            {title}
          </Box>
          {description ? (
            <Typography variant='h6' className='textbase' color='textSecondary'>
              {description}
            </Typography>
          ) : null}
        </Box>
        {refUrl ? (
          <Box height={40}>
            <Button
              variant='outlined'
              color='primary'
              href={refUrl}
              target='_blank'>
              Reference <LinkIcon className='linkIcon' />
            </Button>
          </Box>
        ) : null}
      </StyledComponentHeader>
    </AppAnimate>
  );
};

export default ComponentHeader;

ComponentHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  refUrl: PropTypes.string,
};
ComponentHeader.defaultProps = {};
